module.exports = __webpack_public_path__ + "static/img/16-16.1f08c826.jpeg";